export const useVersionV1 = () => {
  return {
    version: 'v1',
    message: 'This is version 1',
  };
};
